import React, { useState } from "react";
import { toast } from "react-hot-toast";

const PersonalDetails = ({ data, update, next }) => {

    const [form, setForm] = useState(data.personal || {});

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };


    const validate = () => {

        if (!form.firstName) {
            toast.error("First name is required");
            return false;
        }

        if (!form.lastName) {
            toast.error("Last name is required");
            return false;
        }

        if (!form.dob) {
            toast.error("Date of birth is required");
            return false;
        }

        if (!form.gender) {
            toast.error("Gender is required");
            return false;
        }

        if (!form.maritalStatus) {
            toast.error("Marital status is required");
            return false;
        }

        if (!form.mobile) {
            toast.error("Mobile number is required");
            return false;
        }

        if (form.mobile.length !== 10) {
            toast.error("Mobile number must be 10 digits");
            return false;
        }

        if (!form.email) {
            toast.error("Email is required");
            return false;
        }

        if (!/\S+@\S+\.\S+/.test(form.email)) {
            toast.error("Enter valid email address");
            return false;
        }

        return true;
    };


    const handleNext = () => {

        const isValid = validate();
        if (!isValid) return;

        update("personal", form);
        next();
    };


    return (

        <div>

            <h3 className="text-xl font-semibold mb-4">
                Personal Details
            </h3>

            <div className="grid grid-cols-3 gap-5">

                {/* First Name */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        First Name <span className="text-red-500">*</span>
                    </label>

                    <input
                        name="firstName"
                        value={form.firstName || ""}
                        placeholder="First name"
                        onChange={handleChange}
                        className="input w-full"
                    />
                </div>


                {/* Middle Name */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        Middle Name
                    </label>

                    <input
                        name="middleName"
                        value={form.middleName || ""}
                        placeholder="Middle name"
                        onChange={handleChange}
                        className="input w-full"
                    />
                </div>


                {/* Last Name */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        Last Name <span className="text-red-500">*</span>
                    </label>

                    <input
                        name="lastName"
                        value={form.lastName || ""}
                        placeholder="Last name"
                        onChange={handleChange}
                        className="input w-full"
                    />
                </div>


                {/* DOB */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        Date of Birth <span className="text-red-500">*</span>
                    </label>

                    <input
                        name="dob"
                        type="date"
                        value={form.dob || ""}
                        onChange={handleChange}
                        className="input w-full"
                    />
                </div>


                {/* Gender */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        Gender <span className="text-red-500">*</span>
                    </label>

                    <select
                        name="gender"
                        value={form.gender || ""}
                        className="input w-full"
                        onChange={handleChange}
                    >
                        <option value="">Select Gender</option>
                        <option>Male</option>
                        <option>Female</option>
                        <option>Other</option>
                    </select>
                </div>


                {/* Marital Status */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        Marital Status <span className="text-red-500">*</span>
                    </label>

                    <select
                        name="maritalStatus"
                        value={form.maritalStatus || ""}
                        className="input w-full"
                        onChange={handleChange}
                    >
                        <option value="">Select Status</option>
                        <option>Single</option>
                        <option>Married</option>
                        <option>Divorced</option>
                        <option>Widowed</option>
                    </select>
                </div>


                {/* Mobile */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        Mobile Number <span className="text-red-500">*</span>
                    </label>

                    <input
                        name="mobile"
                        maxLength="10"
                        value={form.mobile || ""}
                        placeholder="Enter mobile number"
                        onChange={handleChange}
                        className="input w-full"
                    />
                </div>


                {/* Email */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        Email Address <span className="text-red-500">*</span>
                    </label>

                    <input
                        name="email"
                        value={form.email || ""}
                        placeholder="Enter email"
                        onChange={handleChange}
                        className="input w-full"
                    />
                </div>


                {/* Identification Mark */}
                <div className="col-span-3">
                    <label className="block text-sm font-medium mb-1">
                        Identification Mark
                    </label>

                    <input
                        name="identificationMark"
                        value={form.identificationMark || ""}
                        placeholder="Visible identification mark"
                        onChange={handleChange}
                        className="input w-full"
                    />
                </div>

            </div>


            <button
                onClick={handleNext}
                className="btn-primary mt-6"
            >
                Next
            </button>

        </div>

    );
};

export default PersonalDetails;